<template>
  <div class="w-full py-4 mt-2 mb-2">
    <div class="max-w-[996px] mx-auto flex flex-col items-center text-sm md:flex-row md:justify-between md:text-left">

      <div class="space-x-4 mb-2 md:mb-0">
        <a :href="getLocalizedPath('terms-of-use')" class="text-sm font-normal leading-5 app-text-link">{{ t('terms.term_of_use') }}</a>

        <span class="app-text">|</span>
        <a :href="getLocalizedPath('privacy-policy')" class="text-sm font-normal leading-5 app-text-link">{{ t('terms.privacy_policy') }}</a>

        <span class="app-text">|</span>
        <a href="#" class="text-sm font-normal leading-5 app-text-link" @click.prevent="showMessageDialog = true">{{ t('contact_us') }}</a>

      </div>
      <p class="text-sm leading-5 app-text mt-2 md:mt-0">© {{ currentYear }} Media4Change</p>
    </div>
  </div>

  <MessageModal
    :isVisible="showMessageDialog"
    accountName="Media4change"
    @update:isVisible="showMessageDialog = $event"
    @sendMessage="handleSendMessage"
    user-key="m4c"
  />
</template>

<script setup>
import { ref } from 'vue';
import MessageModal from "@/components/notifications/MessageModal.vue";

const { t, locale } = useI18n();

const currentYear = new Date().getFullYear();
const localePath = useLocalePath();
const toast = useToast();

const showMessageDialog = ref(false);

const handleSendMessage = (data) => {
  toast.add({
    severity: "success",
    summary: 'Message sent',
    life: 3000,
    group: 'tc',
    closable: false
  });
};

const getLocalizedPath = (pageName) => {
  const paths = {
    'terms-of-use': {
      en: '/terms-of-use',
      lt: '/lt/naudojimo-salygos',
    },
    'privacy-policy': {
      en: '/privacy-policy',
      lt: '/lt/privatumo-politika',
    },
  };

  return paths[pageName]?.[locale.value] || paths[pageName]?.en;
};

</script>

<style scoped></style>
